import { useState } from 'react';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import type { IApiSubmitResultBase } from '@/types/api';
import type { IPwlJugStillMissingModel } from '@/types/history/pwl-jug-still-missing';

const PWL_JUG_STILL_MISSING_ENDPOINT = '/api/register/pwl-jug-still-missing';

const defaultPwlJugStillMissingModel: IPwlJugStillMissingModel = {
    status: 'ask',
    languageData: {},
};

type TPwlJugStillMissingResult = IApiSubmitResultBase & { results?: Partial<IPwlJugStillMissingModel> };

export const usePwlJugStillMissing = (registrationId: number, editKey: string) => {
    const url = `${PWL_JUG_STILL_MISSING_ENDPOINT}/${registrationId}/${editKey}`;

    const { model: loaded, isLoading, error } = useApiModel(url, defaultPwlJugStillMissingModel);
    const [override, setOverride] = useState<IPwlJugStillMissingModel | null>(null);
    const model = override ?? loaded;

    const { submit: post, isSubmitting, submitError } = useApiSubmit<void, Partial<IPwlJugStillMissingModel>, TPwlJugStillMissingResult>(
        url,
        () => ({}),
        (results) => ({ results }),
    );

    const sendAnother = () =>
        post().then(({ results }) => {
            if (results) setOverride({ ...defaultPwlJugStillMissingModel, ...results });
        });

    return { model, isLoading, error, sendAnother, isSubmitting, submitError };
};
